import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/network/(pages)/(detail)')({
  component: DetailLayout,
});

function DetailLayout() {
  // Passthrough wrapper for /network/$companyId/* routes.
  // Add shared back-button / breadcrumb here later if needed.
  return <Outlet />;
}
